module.exports = __webpack_public_path__ + "img/fig-intelligent-decision-en.977d2fea.svg";